module.exports = __webpack_public_path__ + "img/source.e1d49d64.png";